import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { ActionButton } from "../../../../../../_metronic/_partials/controls/ActionButton";
import { getDashboardListOrgAll } from "../../../_redux/dashboard/dashboardCrud";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";

export default function InactiveOrgModal({ show, closeModal }) {
  const [inactiveOrgData, setInactiveOrgData] = useState({});
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10
  });
  const {
    actionsLoading,

    auth
  } = useSelector(
    state => ({
      actionsLoading: state.superAdminOrganization.actionsLoading,
      auth: state.auth
    }),
    shallowEqual
  );

  useEffect(() => {
    fetchAllInactiveOrg({
      regional_uuid: auth.user.regional_uuid,
      is_activated: false,
      ...queryParams
    });
  }, [auth.user.regional_uuid, queryParams]);

  function closeModalFunction() {
    closeModal();
  }

  async function fetchAllInactiveOrg(params) {
    try {
      const { data } = await getDashboardListOrgAll(params);
      setInactiveOrgData(data.data);
    } catch (error) {
      console.log(`error`, error);
    }
  }

  const columns = [
    {
      dataField: "name",
      text: "Nama Lembaga",
      classes: "text-nowrap"
    },
    {
      dataField: "is_activated",
      text: "Status",
      classes: "text-nowrap text-center",
      headerStyle: {
        textAlign: "center"
      },
      formatter: () => {
        return (
          <span className="label label-lg label-light-danger label-inline">
            TIDAK AKTIF
          </span>
        );
      }
    }
  ];

  const paginationOptions = {
    custom: true,
    totalSize:
      inactiveOrgData.total_items === null ? 0 : inactiveOrgData.total_items,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "50",
        value: 50
      }
    ],
    sizePerPage:
      inactiveOrgData.pageNumber === null ? 0 : inactiveOrgData.pageNumber,
    page: inactiveOrgData.activePage === null ? 0 : inactiveOrgData.activePage
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        centered
        onHide={closeModalFunction}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Daftar Lembaga Tidak Aktif
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={actionsLoading}
                  paginationProps={paginationProps}
                >
                  <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={false}
                      remote
                      keyField="uuid"
                      data={
                        inactiveOrgData.items === null
                          ? []
                          : inactiveOrgData.items
                      }
                      columns={columns}
                      // defaultSorted={uiHelpers.defaultSorted}
                      onTableChange={getHandlerTableChange(setQueryParams)}
                      {...paginationTableProps}
                    >
                      <PleaseWaitMessage entities={inactiveOrgData.items} />
                      <NoRecordsFoundMessage entities={inactiveOrgData.items} />
                    </BootstrapTable>
                  </div>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center">
            <ActionButton
              type="button"
              loading={actionsLoading}
              style={{ width: "75px", height: "35.59px" }}
              className="btn btn-primary btn-elevate mx-1"
              onClick={closeModalFunction}
              text="Tutup"
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
